package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A single engagement signal on a business listing. [key] is the Firestore counter field name in
 * `businesses/{id}/metrics/counters` — the server-side `recordListingMetric` callable is the only
 * writer, so counters shown to owners are real (never client-inflated).
 */
enum class ListingMetric(val key: String) {
    View("views"),
    Call("calls"),
    Directions("directions"),
    Chat("chats"),
    Share("shares"),
}

/** All-time engagement counters for one listing (owner/admin-readable only). */
data class ListingCounters(
    val views: Long = 0,
    val calls: Long = 0,
    val directions: Long = 0,
    val chats: Long = 0,
    val shares: Long = 0,
) {
    /** A "lead" = any action that puts the customer in contact (the Stitch dashboard's Leads figure). */
    val leads: Long get() = calls + directions + chats
}

/** One UTC day's engagement bucket (`metrics/daily-YYYYMMDD`) for the Listing Analytics trends. */
data class DailyListingCounters(
    /** UTC day as `YYYYMMDD` — sortable string, matches the bucket doc's `day` field. */
    val day: String,
    val counters: ListingCounters,
)
